import "../common.js";
import { $ } from "../utils";

import "../css/pages/home.scss";

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    // video playback
    // -------------------------------------------------------------------------
    const $video = $(".js-video");

    $(".js-video-open").addEventListener("click", () => {
      $video.classList.add("modal--open");
      $video.querySelector("video").play();
    });

    $(".js-video-close").addEventListener("click", () => {
      $video.classList.remove("modal--open");
      $video.querySelector("video").pause();
      $video.querySelector("video").currentTime = 0;
    });

    // about us toggle
    $(".js-about-toggle").addEventListener("click", () => $(".js-about-us").classList.toggle("open"));
  });
})();
